import { RootState } from 'store';
import { IGetServiceDetailsResponse, IServicesResponse } from 'types';

export const getBillServicesSelector = (store: RootState): IServicesResponse | null => store.services.data || null;

export const getServicesIsLoadingSelector = (store: RootState): boolean => store.services.isLoading;

export const getServiceDetailSelector = (store: RootState): IGetServiceDetailsResponse | null =>
	store.services.serviceDetails;
